<template>
  <UkiModal :modalId="modalId" :title="title" @close="$emit('close')" @ok="$emit('ok')">
    <div v-if="showGameTypeOption" class="form-group">
      <label>Тип</label>
      <div class="radio-group">
        <input id="normal-game" :checked="actionAfterComplete === 'NormalGame'" name="action-after-complete-group" type="radio"
               value="NormalGame"
               @input="$emit('update:actionAfterComplete', $event.target.value)"/>
        <label for="normal-game">Обычная игра</label>
        <input id="extra-game" :checked="actionAfterComplete === 'ExtraGame'" name="action-after-complete-group" type="radio"
               value="ExtraGame"
               @input="$emit('update:actionAfterComplete', $event.target.value)"/>
        <label for="extra-game">Экстра игра</label>
      </div>
    </div>
    <div v-if="showGameDropActionOption" class="form-group">
      <label>Действие</label>
      <div class="radio-group">
        <input id="drop-return" :checked="actionAfterDrop === 'Return'" name="drop-action-group" type="radio"
               value="Return" @input="$emit('update:actionAfterDrop', $event.target.value)"/>
        <label for="drop-return">Предыдущая платформа</label>
        <input id="drop-stay" :checked="actionAfterDrop === 'Stay'" name="drop-action-group" type="radio"
               value="Stay" @input="$emit('update:actionAfterDrop', $event.target.value)"/>
        <label for="drop-stay">Плюс игра</label>
      </div>
    </div>
    <template v-if="showRolledGameInfo">
      <div class="form-group">
        <label for="game-name">Название</label>
        <input id="game-name" :value="gameName" required @input="$emit('update:gameName', $event.target.value)"/>
      </div>
      <div class="form-group">
        <label for="game-platform">Платформа</label>
        <uki-select-control id="game-platform"
                            :model-value="gamePlatformId"
                            :options="gamePlatforms"
                            empty-title="Не выбрана"
                            required="true"
                            @update:model-value="value => $emit('update:gamePlatformId', value)"
        />
      </div>
      <div class="form-group">
        <label for="game-genre">Жанр</label>
        <uki-select-control id="game-genre"
                            :model-value="gameGenreId"
                            :options="gameGenres"
                            empty-title="Не выбран"
                            required="true"
                            @update:model-value="value => $emit('update:gameGenreId', value)"
        />
      </div>
      <div class="form-group">
        <label for="region">Регион</label>
        <uki-select-control id="region"
                            :model-value="gameRegion"
                            :options="gameRegions"
                            empty-title="Не выбран"
                            required="true"
                            @update:model-value="value => $emit('update:gameRegion', value)"
        />
      </div>
    </template>
    <div v-if="showDuration" class="form-group">
      <label for="region">Время</label>
      <uki-duration-input id="duration"
                          :model-value="gameDuration"
                          :required="durationRequired"
                          @update:model-value="value => $emit('update:gameDuration', value)"
      />
    </div>
    <template v-if="showDoneGameInfo">
      <div class="form-group">
        <label for="game-rate">Рейтинг</label>
        <input id="game-rate" :value="gameRate" type="number" @input="$emit('update:gameRate', $event.target.value)"/>
      </div>
      <div class="form-group">
        <label for="game-difficulty">Сложность</label>
        <input id="game-difficulty" :value="gameDifficulty" type="number"
               @input="$emit('update:gameDifficulty', $event.target.value)"/>
      </div>
      <div class="form-group">
        <label for="game-rage-meter">Подгорание</label>
        <input id="game-rage-meter" :value="gameRageMeter" type="number"
               @input="$emit('update:gameRageMeter', $event.target.value)"/>
      </div>
      <div class="form-group">
        <label for="game-first-playthrough">Первое прохождение</label>
        <uki-select-control id="game-first-playthrough"
                            :model-value="gameFirstPlaythrough"
                            :options="gameFirstPlaythroughItems"
                            empty-title="Не выбрано"
                            @update:model-value="value => $emit('update:gameFirstPlaythroughs', value)"
        />
      </div>
      <div class="form-group">
        <label for="game-blind">Без подсказок</label>
        <uki-select-control id="game-blind"
                            :model-value="gameBlind"
                            :options="gameBlindItems"
                            empty-title="Не выбрано"
                            @update:model-value="value => $emit('update:gameBlind', value)"
        />
      </div>
    </template>
    <div v-if="showComment" class="form-group">
      <label for="game-comment">Комментарий</label>
      <textarea id="game-comment" :value="gameComment" rows="4"
                @input="$emit('update:gameComment', $event.target.value)">
      </textarea>
    </div>
  </UkiModal>
</template>

<script>
import UkiModal from "@/components/UkiModal";
import UkiSelectControl from "@/components/UkiSelectControl";
import UkiDurationInput from "@/components/UkiDurationInput";

export default {
  name: "EditGameModal",
  components: {UkiDurationInput, UkiSelectControl, UkiModal},
  props: ["modalId", "gameStatus", "gameEditMode", "actionAfterComplete", "actionAfterDrop",
    "gamePlatforms", "gameGenres", "gameRegions", "gameFirstPlaythroughItems", "gameBlindItems",
    "gameId",
    "gameName",
    "gameGenreId",
    "gamePlatformId",
    "gameRegion",
    "gameDuration",
    "gameComment",
    "gameRate",
    "gameDifficulty",
    "gameRageMeter",
    "gameFirstPlaythrough",
    "gameBlind"
  ],
  emits: ["close", "ok",
    "update:actionAfterComplete",
    "update:actionAfterDrop",
    "update:gameName",
    "update:gamePlatformId",
    "update:gameGenreId",
    "update:gameRegion",
    "update:gameDuration",
    "update:gameRate",
    "update:gameDifficulty",
    "update:gameRageMeter",
    "update:gmaeFirstPlaythrough",
    "update:gameBlind",
    "update:gameComment"
  ],
  computed: {
    title: function () {
      if (this.gameEditMode) {
        return "Редактирование игры"
      }

      if (this.gameStatus === "Rolled") {
        return "Наролил игру"
      }

      if (this.gameStatus === "Started") {
        return "Начал проходить"
      }

      if (this.gameStatus === "Reroll") {
        return "Рерол"
      }

      if (this.gameStatus === "Completed") {
        return "Пройдено"
      }

      if (this.gameStatus === "Dropped") {
        return "Дроп"
      }

      return ""
    },
    showRolledGameInfo: function () {
      return this.gameId === null || this.gameEditMode
    },
    showDoneGameInfo: function () {
      return this.gameStatus === "Reroll" || this.gameStatus === "Completed" || this.gameStatus === "Dropped"
    },
    showDuration: function () {
      return (this.gameStatus !== "Rolled" && this.gameStatus !== "Started")
          || this.gameEditMode
    },
    showComment: function () {
      return !this.gameEditMode
    },
    showGameTypeOption: function () {
      return (this.gameStatus === "Completed" || this.gameStatus === "Dropped")
          && !this.gameEditMode
    },
    showGameDropActionOption: function () {
      return (this.gameStatus === "Dropped")
          && !this.gameEditMode
    },
    durationRequired: function () {
      return this.gameStatus === "Completed"
    }
  }
}
</script>

<style scoped>

</style>